'use client'

import DynamicIcon, { IconName } from '@/components/DynamicIcon'
import { Button } from '@/components/ui/button'
import { cn } from '@/utilities/ui'

import type { Topic } from '@/payload-types'

const FilterButton = ({
  topic,
  handleTopicClick,
  activeTopics,
}: {
  topic: Topic & { count: number }
  handleTopicClick: (topic: Topic) => void
  activeTopics: Topic[]
}) => {
  const isSelected = activeTopics.some((t) => t.id === topic.id)

  return (
    <Button
      variant="filter"
      className={cn(isSelected && 'selected')}
      onClick={() => handleTopicClick(topic)}
      disabled={Boolean(topic.count === 0) ?? undefined}
    >
      <span className="flex items-center gap-2">
        <DynamicIcon name={topic.icon as IconName} className="size-4.5" />
        {topic.title}
      </span>
      <span className="text-xs font-normal">{topic.count}</span>
    </Button>
  )
}

export default FilterButton
